/** @format */

import {ChartScaleSettings} from 'components/charts/multiline-chart/model/common';
import {ChartIds} from 'pages/Home/DigitalCast/models/chartIds';
import {Space} from 'pages/Home/DigitalCast/models/spaces';

const getChartScaleSettings = (space: Space): ChartScaleSettings<ChartIds> => {
  const settings: ChartScaleSettings<ChartIds> = {};
  const chartIds = Object.keys(space.widgetsSettings) as ChartIds[];

  chartIds.forEach(id => {
    const scale = space.widgetsSettings[id]?.isScaleChecked;
    if (scale !== undefined) {
      settings[id] = scale;
    }
  });

  return settings;
};

export {getChartScaleSettings};
